import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils.js'
import CSInternalEmailModalUI from './CSInternalEmailModalUI.js'

class CSInternalEmailModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      emailMessage: '',
      emailMessageError: null
    }
  }

  render() {
    return (
      <CSInternalEmailModalUI
        context={this.props.context}
        loan={this.props.loan}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        sendMode={this.props.sendMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        emailMessage={this.state.emailMessage}
        onEmailMessageChange={(event) => { this.setState({ emailMessage: event.target.value }) }}
        emailMessageError={this.state.emailMessageError}
        setEmailMessageError={(error) => { this.setState({ emailMessageError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/csdocuments/newEmailToInternal`,
      this.onSubmitCallback, {
      message: this.state.emailMessage
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(CSInternalEmailModalSF)
